var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m85.992 47.985 8.622-8.438c2.57-2.434 1.372-6.758-2-7.564l-11.747-2.998 3.312-11.628c.936-3.344-2.218-6.5-5.562-5.563l-11.623 3.312-2.997-11.75c-.794-3.319-5.166-4.533-7.561-2L48 10.043l-8.435-8.688c-2.369-2.504-6.76-1.356-7.561 2l-2.997 11.75-11.624-3.312c-3.345-.936-6.497 2.22-5.562 5.563l3.312 11.628-11.747 2.998c-3.373.807-4.57 5.132-2 7.564l8.622 8.438-8.622 8.438c-2.57 2.434-1.372 6.758 2 7.564l11.746 2.998-3.311 11.628c-.936 3.344 2.218 6.5 5.561 5.563l11.624-3.312 2.997 11.75c.833 3.483 5.193 4.504 7.561 2L48 85.99l8.435 8.626c2.344 2.529 6.748 1.403 7.561-2l2.997-11.751 11.624 3.312c3.344.937 6.497-2.22 5.562-5.563l-3.312-11.628 11.747-2.998c3.373-.807 4.569-5.131 2-7.564l-8.622-8.438z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.b0be33b30ca7b9be6ab6910da5b2416d.svg";
export { ForwardRef as ReactComponent };